import { BadgeProps } from "react-bootstrap";

export interface IBadgeProps extends BadgeProps {
  packageStatus?: string;
}

export const DefaultBadgeProps: IBadgeProps = {
  packageStatus: undefined,
};
